import { connect } from "react-redux";

import { selectDisplayedPagesOnRightSidebar } from "~/store/selectors/page";
import {
  selectRightSidebarActiveItems,
  toggleSidebarRightMenuItem,
  selectIsPresentationActive,
  selectIsPresentationMaterialVisible,
  toggleIsPresentationMaterialVisible
} from "~/store/ducks/user/uistate";
import { selectTypeSizesByPages } from "~/store/ducks/application/materials/materials";
import { selectMarkedMaterialsSize } from "~/store/selectors/dls";

import RightSidebarMenuSmall from "./RightSidebarMenuSmall";

function mapStateToProps(state) {
  const pages = selectDisplayedPagesOnRightSidebar(state);

  return {
    activeItems: selectRightSidebarActiveItems(state),
    materialSizes: selectTypeSizesByPages(pages)(state),
    isPresentationActive: selectIsPresentationActive(state),
    isPresentationMaterialVisible: selectIsPresentationMaterialVisible(state),
    markedMaterialsSize: selectMarkedMaterialsSize(state)
  };
}

const mapDispatchToProps = dispatch => ({
  onItemToggle: itemType => event => {
    dispatch(toggleSidebarRightMenuItem(itemType));
  },
  onPresentationToggle: event => {
    dispatch(toggleIsPresentationMaterialVisible());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RightSidebarMenuSmall);
